<template>
  <div>
<!-- <script type="text/template" id="job-one-column-template"> -->
    <template  v-for="(location, index) in data">
      <div class="single-info jobs-location" :key="`1.${index}`">
        <p class="one-location" :data-id="location.id" @click="onLocationClick(location.pk)">
          <span class="com-name"></span>
          <span>{{ location.i18n_city_name }}</span>
          <span>&nbsp;--&nbsp;</span>
          <span>{{ $t('common.appleStore') }}</span>
          <ins class="icon_joblink_down" :ref="`link_${location.pk}`"></ins>
        </p>
      </div>
      <div
        class="single-info jobs"
        style="display: none;"
        :ref="`div_jobs_${location.pk}`"
        :key="`2.${index}`">
        <ul>
          <li v-for="(job, jobIndex) in location.job_data" :key="jobIndex">
            <span @click="jobApply(job)">
              <div class="desc-job-detail location-jobs-detail">
                <a class="apple-job-name">{{ job.title }}</a>
                <p class="job-city">
                  <span class="com-name"></span>
                  <!-- <% _.each(job.cities, function (city) { %>
                    <%= city %>&nbsp;
                  <% }); %> -->
                  {{ job.cities && job.cities.join(' ') }}
                </p>
                <p class="job-expired-time">
                  <span class="com-name"></span>
                  {{ job.updated_time }}
                </p>
              </div>
              <div v-if="job.referral_settings && job.referral_settings.to_show_referral" class="show_referral">
                <img v-if="job.company.has_referral_word_customized" class="customized_referral" :src="$DjangoStaticUrl(`image/marketing/jd_customized/${company.root_company.id}-red-pocket.png`)" />
                <span v-else-if="job.company.show_equivalent_reward" class="balance">
                  {{ $t('companyJobList.btn.winRewards') }}
                </span>
                <span v-else class="balance">
                  <span>{{ $t('common.reward') }}</span>
                  <span>{{ $t('common.rmb') }}</span>
                  <span class="balance-format">{{ job.referral_settings.to_show_referral }}</span>
                </span>
              </div>
            </span>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    ...mapActions('referral', ['getJobReferralUrl']),
    async jobApply (job) {
      const listReferralId = this.$route.query.lReferId
      const jobId = job.pk
      let url = ''
      if (listReferralId) {
        url = await this.getJobReferralUrl({ listReferralId, jobId })
      }
      if (!url) {
        const id = job.short_unique_id
        url = `/job-description/${id}/?company_id=${this.company.id}`
      }
      this.$router.push({ path: url, query: this.$route.query })
    },
    onLocationClick (id) {
      const linkIcon = this.$refs[`link_${id}`][0]
      const jobContainer = this.$refs[`div_jobs_${id}`][0]
      if (linkIcon.classList.contains('icon_joblink_down')) {
        linkIcon.classList.replace('icon_joblink_down', 'icon_joblink_up')
        jobContainer.style.display = ''
      } else {
        linkIcon.classList.replace('icon_joblink_up', 'icon_joblink_down')
        jobContainer.style.display = 'none'
      }
    }
  }
}
</script>

<style>
</style>
